import { render } from "./CloneModuleModal.vue?vue&type=template&id=4570a552&scoped=true&ts=true"
import script from "./CloneModuleModal.vue?vue&type=script&lang=ts"
export * from "./CloneModuleModal.vue?vue&type=script&lang=ts"

import "./CloneModuleModal.vue?vue&type=style&index=0&id=4570a552&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4570a552"]])

export default __exports__